var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRadio02Checked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10.5,
  fill: "#fff",
  stroke: "#E2E2E2"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 6,
  fill: "#000"
})));
export default SvgIconRadio02Checked;